import React from 'react';
import { formatCodeAmount } from '../../utils/analytics';

const TopBilledCodesBody = ({ codes = [] }) => {
  if (codes.length === 0) {
    return <span className="top-billed-codes__empty">No billed codes</span>;
  }

  return (
    <div className="top-billed-codes">
      <div className="top-billed-codes__header" aria-hidden="true">
        <span />
        <span>min</span>
        <span>median</span>
        <span>max</span>
      </div>

      <div className="top-billed-codes__rows">
        {codes.map((code) => (
          <div key={code.hcpcs} className="top-billed-codes__row">
            <span className="top-billed-codes__name">{code.hcpcs}</span>
            <span className="top-billed-codes__amount">{formatCodeAmount(code.min)}</span>
            <span className="top-billed-codes__amount">{formatCodeAmount(code.median)}</span>
            <span className="top-billed-codes__amount">{formatCodeAmount(code.max)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopBilledCodesBody;
